$(function() {
    /**
     * Formats a cents integer into a human readable money string. Taken
     * directly from Shopify's Timber framework
     */
    function formatMoney(cents, format) {
        var value = '',
            placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;

        if (typeof cents == 'string') {
            cents = cents.replace('.','');
        }

        function defaultOption(opt, def) {
            return (typeof opt == 'undefined' ? def : opt);
        }

        function formatWithDelimiters(number, precision, thousands, decimal) {
            precision = defaultOption(precision, 2);
            thousands = defaultOption(thousands, ',');
            decimal = defaultOption(decimal, '.');

            if (isNaN(number) || (!number && typeof number != "number")) {
                return 0;
            }

            number = (number/100.0).toFixed(precision);

            var parts = number.split('.'),
                dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands),
                cents = parts[1] ? (decimal + parts[1]) : '';

            return dollars + cents;
        }

        switch(format.match(placeholderRegex)[1]) {
            case 'amount':
                value = formatWithDelimiters(cents, 2);
                break;
            case 'amount_no_decimals':
                value = formatWithDelimiters(cents, 0);
                break;
            case 'amount_with_comma_separator':
                value = formatWithDelimiters(cents, 2, '.', ',');
                break;
            case 'amount_no_decimals_with_comma_separator':
                value = formatWithDelimiters(cents, 0, '.', ',');
                break;
        }

        return format.replace(placeholderRegex, value);
    }

    function switchImage(slides, dots, incrementor, isAbsolute) {
        var visibleIndex = -1;

        // Sadly, jQuery's index method doesn't work as indexOf on a set, so we
        // default to the cruder method of a simple jQuery.each loop
        slides.each(function(i, element) {
            if ($(element).is('.is-visible')) {
                visibleIndex = i;
            }
        });

        $(slides[visibleIndex]).removeClass('is-visible');

        var nextIndex = (isAbsolute ? incrementor : visibleIndex + incrementor) % slides.length;
        nextIndex = nextIndex < 0 ? slides.length - 1 : nextIndex;
        $(slides[nextIndex]).addClass('is-visible');
        $(dots).removeClass('is-active');
        $(dots[nextIndex]).addClass('is-active');

        return nextIndex;
    }

    var sliderRunning = true,
        sliderInterval;

    sliderInterval = setInterval(function(){
        var slides = $('.js-slide'),
            dots = $('.js-sliderDot');
        switchImage(slides, dots, 1);
    }, 5000);

    $('.js-nextSlideButton, .js-slide').on('click', function() {
        var slides = $(this).parent().find('.js-slide'),
            dots = $(this).parent().find('.js-sliderDot');

        switchImage(slides, dots, 1);

        if ( sliderRunning ) {
            clearInterval(sliderInterval);
            sliderRunning = false;
        }

        return false;
    });

    $('.js-prevSlideButton').on('click', function() {
        var slides = $(this).parent().find('.js-slide'),
            dots = $(this).parent().find('.js-sliderDot');

        switchImage(slides, dots, -1);

        if ( sliderRunning ) {
            clearInterval(sliderInterval);
            sliderRunning = false;
        }

        return false;
    });

    $('.js-sliderDots').each(function(i, element) {
        var dotsContainer = $(this),
            imageSlider = dotsContainer.parents('.js-imageSlider'),
            slides = imageSlider.find('.js-slide');

        slides.each(function(i) {
            var className = 'Slider-dot js-sliderDot ' + (i === 0 ? 'is-active' : ''),
                dot = $('<a href="#" class="' + className + '"></a>');

            dot.on('click', function(event) {
                var dots = imageSlider.find('.js-sliderDot');
                switchImage(slides, dots, i, true);

                if ( sliderRunning ) {
                    clearInterval(sliderInterval);
                    sliderRunning = false;
                }

                return false;
            });

            dotsContainer.append(dot);
        });
    });

    function checkHeader() {
        var scroll = $(window).scrollTop();

        if ( $('.Header').hasClass('jsCheckHeader') ) {
            if ( scroll > 1 ) {
                $('.Header:not(.Header--filled)').addClass('Header--filled');
            } else {
                $('.Header.Header--filled').removeClass('Header--filled');
            }
        }
    }

    function checkGrid() {
        var scroll = $(window).scrollTop(),
            windowHeight = $(window).outerHeight(),
            viewPortBreak = scroll+windowHeight,
            documentHeight = $(document).outerHeight(),
            documentBottomTop = (documentHeight-windowHeight);

        $('.Grid-col').each(function(){
            var top = $(this).offset().top;

            if (viewPortBreak > top) {
                $(this).addClass('js-inView');
            }
        });
    }

    $('.js-menuItem > a').each(function(i, element) {
        var isActive = element.pathname.replace(/\/$/, "") === location.pathname.replace(/\/$/, "");
        $(element).parent().toggleClass("Menu-item--active", isActive);
    });

    $(".js-slideThumbnail").on("click", function(event) {
        var index = $(this).index(),
            sliderTarget = $(this).attr("data-target"),
            slider = $(".js-slider[data-name='" + sliderTarget + "']"),
            slides = slider.find(".js-slide");

        slides.removeClass("is-active");
        $(slides[index]).addClass("is-active");
        $(this).siblings().removeClass("is-active");
        $(this).addClass("is-active");
    });

    $(".js-playOnHover")
        .on("mouseenter", function() {
            this.play();
        })
        .on("mouseleave", function() {
            this.pause();
        });

    $(".js-productSizeInput").on("change", function(event) {
        $(".js-addToCart").removeAttr("disabled");
    });

    function overlayLinkListener(event) {
        var href = $(this).attr("href"),
            toggleClass = $(this).attr("data-toggle-class");

        $(".BodyOverlay.is-visible:not(" + href + ")").removeClass("is-visible");
        $(href).toggleClass(toggleClass || "is-visible");
        return $(this).attr("data-prevent-default") === "false" ? true : false;
    }

    $(".js-overlayLink").on("click", overlayLinkListener);

    $(".js-searchLink").on("click", function() {
        var href = $(this).attr("href");
        var $target = $(href);
        $(this).parents(".Menu-item").toggleClass("is-active");
        $target.toggleClass("is-visible");

        if ($target.hasClass("is-visible")) {
            $target.find("input").focus();
        }

        return false;
    });

    $.views.converters("money", function(val) {
        var format = $(".Cart").attr("data-money-format");
        return formatMoney(val, format);
    });

    $.views.converters("shoesize", function(val) {
        return val[0];
    });

    $.views.converters("stripsize", function(val) {
        return val.replace(/\s+-\s+\d+$/, "");
    });

    function renderCart(element, data) {
        data.items.forEach(function(item, i) {
            item.index = i + 1;
        });

        var template = $.templates(".js-cartTemplate"),
            output = template.render(data);

        $(element).html(output);

        $(element).find(".js-removeCartItem").on("click", function(event) {
            var href = $(this).attr("href");

            $.ajax("/cart/change.js", {
                dataType: "json",
                method: "POST",
                data: {
                    line: $(this).index() + 1,
                    quantity: 0
                },
                success: function(data) {
                    renderCart(element, data);
                }
            });

            return false;
        });

        $(element).find(".js-overlayLink").on("click", overlayLinkListener);
    }

    var cartJson = $(".js-cartData").text(),
        cartData = JSON.parse(cartJson);

    $(".js-cart").each(function(i, element) {
        renderCart(element, cartData);
    });

    $(".js-productForm").on("submit", function(event) {
        $.ajax("/cart/add.js", {
            dataType: "json",
            method: "POST",
            data: $(event.target).serialize(),
            success: function(data) {
                $.ajax("/cart.js", {
                    dataType: "json",
                    success: function(data) {
                        renderCart($(".js-cart"), data);

                        $("#cart")
                            .addClass("is-visible")
                            .one("transitionend", function() {
                                //setTimeout(function() {
                                //    $("#cart").removeClass("is-visible");
                                //}, 1500);
                            });
                    }
                });
            }
        });

        return false;
    });

    $('body').on('click', '[name="checkout"], [name="goto_pp"], [name="goto_gc"]', function() {
        if ($('#agree').is(':checked')) {
            $(this).submit();
        } else {
            $(this).parents('.Cart-footer').find('.Cart-agreement').addClass('Cart-agreement--highlight');
            return false;
        }
    });

    $('.Cart-checkbox').on('change',function(){
        $(this).parents('.Cart-agreement.Cart-agreement--highlight').removeClass('Cart-agreement--highlight');
    });

    var iframe = $("iframe[src*='player.vimeo.com']");

    if (iframe.length) {
        var player = new Vimeo.Player(iframe[0]);

        player.ready().then(function() {
            player.setVolume(0);
        });
    }

    $(".js-mobileMenu").on("click", function(){
        $('body').toggleClass('is-mobileMenu');
    });

    $(".js-wishlist").on("click", function(){
        $(this).hide();
        $('.Details-wishlist').addClass('Details-wishlist--open');
    });

    window.addEventListener("scroll", function() {
        checkHeader();
        checkGrid();
    }, { passive: true });

    // jQuery's trigger method unfortunately doesn't trigger the event we
    // registered with the native addEventListener method, so we need to
    // dispatch a native scroll event to call our functions when the page loads
    var event = new Event('scroll');
    window.dispatchEvent(event);
});
